import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@shared/shared.module';
import { ViewOffersModule } from '@view-offers/view-offers.module';
import { CompareModule } from '../compare/compare.module';
import * as fromComponents from './components';
import * as fromContainers from './containers';
import { ProductDetailsEffects } from './store/effects/index';
import {
  PRODUCT_DETAILS_FEATURE,
  productDetailsReducers,
} from './store/reducers/index';
import { calendarReducer } from './store/reducers/selected.delivery.date.reducer';

@NgModule({
  declarations: [...fromComponents.components, ...fromContainers.containers],
  imports: [
    CommonModule,
    SharedModule,
    ViewOffersModule,
    CompareModule,
    StoreModule.forFeature(PRODUCT_DETAILS_FEATURE, productDetailsReducers),
    StoreModule.forFeature('calendar', calendarReducer),
    EffectsModule.forFeature(ProductDetailsEffects),
    DgxQmModule.forRoot(),
    DgxComponentsButtonModule,
    DgxComponentsIconModule,
    RouterModule,
  ],
  exports: [...fromComponents.components, ...fromContainers.containers],
})
export class ProductDetailsModule {}
